import { Outlet, createFileRoute } from '@tanstack/react-router';

import { ProductLogoMediumAccesses } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';

export const Route = createFileRoute('/_staff/accesses/_layout')({
  component: Layout,
});

function Layout() {
  const { t } = useTranslation(defaultNS, { keyPrefix: 'pages.accesses' });
  useDocumentTitle(t('productHeader.pageTitle'));

  const tabs = [
    {
      to: '/accesses/overview',
      children: t('nav.overview'),
      disabled: true,
    },
    {
      to: '/accesses/list',
      children: t('nav.logs'),
    },
    {
      to: '/accesses/software',
      children: t('nav.software'),
      disabled: true,
    },
    {
      to: '/accesses/alerts',
      children: t('nav.alerts'),
    },
    {
      to: '/accesses/contract-and-cost',
      children: t('nav.contractAndCost'),
      disabled: true,
    },
    {
      to: '/accesses/settings',
      children: t('nav.settings'),
    },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div>
      <ProductHeader
        Logo={ProductLogoMediumAccesses}
        name={t('productHeader.pageTitle')}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
